import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Public page Meta shows after a Facebook data-deletion request. It makes no
 * API call: the backend already deleted the data and only echoes the code.
 */
const FacebookDataDeletion = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const code = params.get('code')?.trim() || null;

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle>{code ? t('facebookDataDeletion.title') : t('facebookDataDeletion.neutralTitle')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          {code ? (
            <>
              <p>{t('facebookDataDeletion.body')}</p>
              <p
                className="break-all rounded-md border bg-muted px-3 py-2 font-mono text-base text-foreground"
                data-testid="facebook-deletion-code"
              >
                {code}
              </p>
            </>
          ) : (
            <p>{t('facebookDataDeletion.missingCode')}</p>
          )}
        </CardContent>
      </Card>
    </main>
  );
};

export default FacebookDataDeletion;
